import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type FAQItem = {
  question: string;
  answer: string;
};
type FAQAccordionProps = {
  items: FAQItem[];
};
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="mx-auto mt-9 max-w-4xl space-y-2" data-id="element-7">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      const panelId = `faq-panel-${index}`;
      return <article key={item.question} className="overflow-hidden rounded-xl border border-emerald-100 bg-white" data-id="element-8">
            <h3 data-id="element-9">
              <button type="button" className="flex w-full items-center justify-between gap-4 p-5 text-left text-sm font-black text-emerald-950 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-emerald-500" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-10">
                {item.question}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-emerald-600 transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-11" />
              </button>
            </h3>
            {isOpen && <div id={panelId} role="region" className="border-t border-emerald-100 px-5 py-4 text-sm leading-6 text-slate-600" data-id="element-12">
                {item.answer}
              </div>}
          </article>;
    })}
    </div>;
}